module.exports = __webpack_public_path__ + "static/img/drainage.524f7836.png";